export default __webpack_public_path__ + "static/media/grafema_minha-casa_06.68215d0c.jpg";